import React from "react";
import classNames from "classnames";
import "./index.scss";

const AmountControl = ({ value }) => {
    return (<div className={classNames("amountControl")}>{value || 0}</div>);
}

export default AmountControl;